import React from 'react'

import LlmSettingsPanel from './LlmSettingsPanel'

// "LLM settings" drawer tab for subagent nodes: per-node model / temperature /
// reasoning-effort overrides, with unset fields inheriting the agent-level
// settings (AVR-527).
const ModelTab = ({ node }) => (
  <div className="voice-agents__drawer-tab" data-testid="drawer-tab-model">
    <LlmSettingsPanel nodeId={node.id} />
  </div>
)

export default ModelTab
